import { Sha256 } from '@aws-crypto/sha256-js';

import { IS_CLIENT, IS_MOBILE } from '../constants/session';

export const uuidV4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const sha256Hash = async (value: string) => {
  if (!value) return value;
  const formatHash = new Sha256();
  formatHash.update(Buffer.from(value, 'utf-8'));
  const result = await formatHash.digest();
  return uint8ArrayToHexString(result);
};

export const uint8ArrayToHexString = (array: Uint8Array): string => {
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const copyToClipboard = (text: string, callback?: () => void, onError?: (error: unknown) => void) => {
  if (IS_CLIENT) {
    if (window.navigator?.clipboard) {
      window.navigator.clipboard
        .writeText(text)
        .then(() => {
          if (callback) {
            callback();
          }
        })
        .catch((error) => {
          console.error(error);
          if (onError) {
            onError(error);
          }
        });
    } else {
      // iOS 13.4 미만용
      const textArea = document.createElement('textarea');
      document.body.appendChild(textArea);
      textArea.value = text;
      textArea.select();

      try {
        const succeeded = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (succeeded) {
          if (callback) {
            callback();
          }
        } else if (onError) {
          onError(new Error('execCommand copy failed'));
        }
      } catch (error) {
        document.body.removeChild(textArea);
        console.error(error);
        if (onError) {
          onError(error);
        }
      }
    }
  }
};

export const sharePage = (
  data: {
    title: string;
    text?: string;
    url: string;
  },
  callback?: () => void
) => {
  if (IS_CLIENT) {
    if (window.navigator?.share && IS_MOBILE) {
      window.navigator
        .share({
          title: data.title,
          text: data.text,
          url: data.url
        })
        .catch(console.error);
    } else {
      copyToClipboard(data.url, callback);
    }
  }
};

export const addQueryParamsUrl = (url: string, params: Record<string, string | string[] | undefined>) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === 'undefined') return;
    if (Array.isArray(value)) {
      value.forEach((item) => queryParams.append(key, item));
    } else {
      queryParams.append(key, value);
    }
  });

  const queryString = queryParams.toString();
  if (!queryString) {
    return url;
  }

  const queryDelimiter = url.includes('?') ? '&' : '?';
  return `${url}${queryDelimiter}${queryString}`;
};

export const padNumberLeft = (num: number, length: number) => String(num).padStart(length, '0');

export const limitStringLength = (value: string, length: number) => (value.length < length ? value : value.slice(0, length));

export const convertPhoneNumberFormat = (value: string, separator: string = '-') => {
  if (!value) {
    return '';
  }

  value = value.replace(/[^0-9]/g, '');

  const resultArray = [];
  let restNumber: string;

  if (value.startsWith('1')) {
    restNumber = value;
  } else {
    resultArray.push(value.substring(0, 3));
    restNumber = value.substring(3);
  }

  if (restNumber.length === 7) {
    // 7자리만 남았을 때는 xxx-yyyy
    resultArray.push(restNumber.substring(0, 3));
    resultArray.push(restNumber.substring(3));
  } else {
    resultArray.push(restNumber.substring(0, 4));
    resultArray.push(restNumber.substring(4));
  }

  const result = resultArray.filter((val) => val).join(separator);

  return limitStringLength(result, 13);
};
